module.exports = __webpack_public_path__ + "img/KSC02898.6bedd086.jpg";